export const SequenceTaskEN = {
    sequenceTask: "Sequence task",
    create: "You create",
    assigned: "You assigned",
    sequenceTaskDetail: "Detail sequence task",
    sequenceTaskInfo: "Sequence task information",
    sequenceTaskHistory: "Sequence task history",
    sequenceTaskNoti: "Allow notification",
    sequenceTaskButton: {
        next: "Transfer handle",
        completed: "Completed"
    },
    sequenceTaskLabel: {
        name: "Sequence task name",
        deadline: "Deadline",
        assign: "Assignee",
        follower: "Followers",
        dynamicForm: "Dynamic form",
        description: "Description",
        assignToOther: "Assign to other",
        status: "Status",
        idea: "Idea",
        checklist: "Checklist",
        files: "List of attached documents",
        assignmentDate: "Assignment Date",
        processingDate: "Processing Date",
        project: "Project",
        phase: "Phase",
        parentTask: "Parent Task",
        progress: "Progress",
    },
    sequenceTaskPlaceholder: {
        name: "Type sequence task name",
        deadline: "Type deadline",
        assign: "Choose assignee",
        follower: "Choose follower",
        dynamicForm: "Choose dynamic form",
        description: "Type description",
        idea: "Type idea",
        status: "Choose status"
    },
    sequenceTaskRequired: {
        name: "Sequence task name is required",
        deadline: "Deadline is required",
        assignee: "Assignee is required"
    },
    sequenceTaskColumns: {
        name: "Sequence task name",
        assignee: "Assignee",
        follower: "Followers",
        progress: "Progress",
        deadline: "Deadline",
        status: "Status"
    },
    sequenceTaskStatus: {
        doing: "Doing",
        completed: "Completed",
        expired: "Expired"
    }
}